import { http } from '@/lib/api';
import { config } from '@/lib/config';
import { DEMO_ASSISTANT_QA } from '@/mocks/fixtures/assistant';
import { mockApi } from '@/mocks/mock-api';

export interface AssistantAnswer {
  answer: string;
  /** Deep link the answer refers to, rendered as "Ver detalle →". */
  link?: { label: string; to: string };
}

/** Sends a question to KainOS AI and returns its answer. */
export async function askAssistant(question: string): Promise<AssistantAnswer> {
  if (config.useMocks) {
    return {
      answer: await mockApi.askAssistant(question),
      link: { label: 'Ver detalle', to: '/attention' },
    };
  }

  return http.post<AssistantAnswer>('/ai/assistant', { question });
}

/** Starter questions offered under the composer. */
export function getSuggestedQuestions(): string[] {
  return DEMO_ASSISTANT_QA.map((entry) => entry.question);
}
